import observer from 'saddlebag-observer';

import type { TrackProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/DestinationsExplorer';

const TRACKING_EVENT = 'tracking-event';
const CATEGORY = 'destinations-explorer';

const ACTION_TYPES = {
  COMPONENT_LOADED: 'ComponentLoaded',
  SELECT_RESULT: 'SelectResult',
  SELECT_MAP_LINK: 'SelectMapLink',
  SELECT_EXPLORE_ALL: 'SelectExploreAll',
};

const actionMappings = {
  [ACTION_TYPES.COMPONENT_LOADED]: {
    name: 'Destinations Explorer Loaded',
    label: (props: TrackProps) =>
      `origin_${props.origin?.toLowerCase()}_destination_${props.destination?.toLowerCase()}`,
  },
  [ACTION_TYPES.SELECT_RESULT]: {
    name: 'Destinations Explorer Result Selected',
    label: (props: TrackProps) =>
      `${props.position}_${props.direct}_${props.priced}_image-${
        props.imageAvailable
      }_${props.placeCode?.toLowerCase()}`,
  },
  [ACTION_TYPES.SELECT_MAP_LINK]: {
    name: 'Destinations Explorer Map Link Selected',
    label: (props: TrackProps) => String(props.origin?.toLowerCase()),
  },
  [ACTION_TYPES.SELECT_EXPLORE_ALL]: {
    name: 'Destinations Explorer Explore All Selected',
    label: (props: TrackProps) => String(props.destination?.toLowerCase()),
  },
};

const trackEvent = (props: TrackProps, action: string) => {
  if (!props) {
    return;
  }

  observer.publish(TRACKING_EVENT, {
    ga: [
      {
        category: CATEGORY,
        action,
        label: actionMappings[action].label(props),
      },
    ],
  });
};

const trackComponentLoaded = (props: TrackProps) =>
  trackEvent(props, ACTION_TYPES.COMPONENT_LOADED);

const trackSelectResult = (props: TrackProps) =>
  trackEvent(props, ACTION_TYPES.SELECT_RESULT);

const trackSelectMapLink = (props: TrackProps) =>
  trackEvent(props, ACTION_TYPES.SELECT_MAP_LINK);

const trackSelectExploreAll = (props: TrackProps) =>
  trackEvent(props, ACTION_TYPES.SELECT_EXPLORE_ALL);

export {
  trackComponentLoaded,
  trackSelectResult,
  trackSelectMapLink,
  trackSelectExploreAll,
};
